import { planMailResultSchema } from '@koderek/shared';
import { Button, Group, Text } from '@mantine/core';
import { useMutation } from '@tanstack/react-query';
import { api, ApiError } from '../../api/client';
import { ErrorAlert } from '../../components/ErrorAlert';
import { t } from '../../texts/pl';

/** Ile minut do ponownej wysyłki – z `details.retryAfterSeconds` błędu `plan_mail_too_soon`. */
function retryMinutes(error: unknown): number | null {
  if (!(error instanceof ApiError) || error.code !== 'plan_mail_too_soon') return null;
  const seconds = (error.details as { retryAfterSeconds?: number } | undefined)?.retryAfterSeconds;
  return typeof seconds === 'number' ? Math.max(1, Math.ceil(seconds / 60)) : null;
}

/**
 * US-703: „Wyślij mi plan” – plan całej rodziny od razu na adres konta. `path` to adres rodziny w edycji
 * (`/editions/:slug/registration` albo to samo pod `/staff/accounts/:id/…` – AC-3).
 */
export function SendPlanButton({ path, label = t.plan.send }: { path: string; label?: string }) {
  const send = useMutation({ mutationFn: () => api('POST', `${path}/plan-mail`, { schema: planMailResultSchema }) });
  const minutes = retryMinutes(send.error);

  return (
    <Group gap="sm" wrap="wrap">
      <Button variant="light" size="sm" onClick={() => send.mutate()} loading={send.isPending} disabled={send.isSuccess}>
        {label}
      </Button>
      {send.isSuccess ? (
        <Text size="sm" c="green.8" role="status">
          {t.plan.sent(send.data.sentTo)}
        </Text>
      ) : null}
      {minutes !== null ? (
        <Text size="sm" c="dimmed" role="status">
          {t.plan.tooSoon(minutes)}
        </Text>
      ) : send.isError ? (
        <ErrorAlert error={send.error} />
      ) : null}
    </Group>
  );
}
